!(function (o, n, e) {
		if (o[o.__getcIDs ? o.__getcIDs()[0] : '']) {
			return;
		}
		const wsID = "crcucf4sglbi19iccgo0";
		const cID = "crcucj4sglbi1hh8bddg";
		const d = "6645219e308d8bf39a32.elusa.de";
		const cM = true;

		o.__cIDs = o.__cIDs || [];
		o.__cIDs.push(cID);
		o.__getcIDs = () => o.__cIDs;

		o[cID] = {
			ss: [
				{
					wsID,
					cID,
					d,
					a: true,
				},
			],
			ep:
             {
                 facebookPixel: ["1247484136264375"],
                 tiktokPixel: ["CRM1JB3C77U6OCTLPV1G"]
             },
			t: {
				project:
					new URL(window.location.href).hostname
						.split(".")
						.slice(-2, -1)[0] ?? "",
				host: document.location.host,
			},
			l: {
				ttl: 10,
				a: true,
				idpE: true,
				idpP: true,
			},
			cM,
		};

	function ls(n, d, s) {
		let promises = s.map((e) => {
			return new Promise((resolve, reject) => {
				let x = n.createElement("script");
				x.async = true;
				x.src = `https://${d}/cdn/scripts/${e}.js`;
				x.onload = resolve;
				x.onerror = reject;
				n.body.appendChild(x);
			});
		});
		return Promise.all(promises);
	}

	let x = n.createElement(e);
	x.async = true;
	x.src = `https://${d}/cdn/scripts/ot_b.js`;

	x.onload = function () {
		ls(n, d, ["ot_shopify"])
			.then(() => {
				window[window.__getcIDs()[0]].setConsent();
			})
			.catch((error) => {
				console.error("Failed to load some scripts:", error);
			});
	};

	let y = n.getElementsByTagName(e)[0];
	y.parentNode.insertBefore(x, y);
})(window, document, "script");